import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeginYourRecovery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21892" id="begin-the-journey" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-[160px]">
      {}
      <div className="absolute inset-0 bg-background -z-20" />

      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none -z-10">
        <svg className="w-full h-full" viewBox="0 0 1440 800" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
          <path d="M-100 400 C 200 300, 400 500, 700 400 C 1000 300, 1200 500, 1500 400" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M-100 450 C 200 350, 400 550, 700 450 C 1000 350, 1200 550, 1500 450" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M-100 500 C 200 400, 400 600, 700 500 C 1000 400, 1200 600, 1500 500" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M-100 350 C 200 250, 400 450, 700 350 C 1000 250, 1200 450, 1500 350" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M-100 300 C 200 200, 400 400, 700 300 C 1000 200, 1200 400, 1500 300" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M-100 550 C 200 450, 400 650, 700 550 C 1000 450, 1200 650, 1500 550" stroke="currentColor" strokeWidth="1" fill="none" />
        </svg>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className={`transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-7xl font-serif font-light text-foreground mb-6 tracking-tight">
            Ready for the Echelon Experience?
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed font-sans font-light tracking-normal">
            Join us in curating an unforgettable soirée tailored to your discerning taste. 
            Let's begin the coordination of your next masterpiece today.
          </p>

          <div className="flex justify-center">
            <Button asChild size="lg" className="bg-transparent border border-secondary text-secondary hover:bg-secondary hover:text-primary-foreground text-sm tracking-widest uppercase px-12 py-6 h-auto rounded-none shadow-none transition-all duration-700">
              <Link to="/InquirePage">
                <span className="font-light">Inquire Now</span>
                <ArrowRight className="ml-3 w-4 h-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}